const { default: styled } = require('styled-components');

export const AssistanceFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 8px;
  gap: 16px;
  height: 100%;

  > button {
    width: fit-content;
  }
`;
